<template>
  <a-popover trigger="click" v-model:visible="visible">
    <template #content>
      <div class="mr-[-16px]">
        <!-- 搜索 -->
        <div class="pb-[12px] px-[40px] bg-white flex justify-end">
          <a-input v-model:value="keyword" allowClear class="!w-[400px]">
            <template #suffix>
              <SearchOutlined class="text-[12px]" />
            </template>
          </a-input>
        </div>
        <div class="w-[800px]">
          <a-tabs size="small" tabPosition="left" v-if="hasChild">
            <a-tab-pane
              v-for="(option, index) in localOptions"
              :tab="option[fieldNames.label]"
              :key="index"
            >
              <SelectOptions
                :value="localValue"
                :options="option[fieldNames.options]"
                :field-names="fieldNames"
                @change="handleCheckChange"
              />
            </a-tab-pane>
          </a-tabs>
          <SelectOptions
            v-else
            :value="localValue"
            :options="localOptions"
            :field-names="fieldNames"
            @change="handleCheckChange"
          />
        </div>
      </div>
    </template>
    <a-select
      class="min-w-[180px] shrink-0 grow-0"
      v-model:value="localValue"
      v-bind="$attrs"
      :options="localOptions"
      :dropdownStyle="{ display: 'none' }"
      :field-names="fieldNames"
      :mode="mode"
    />
  </a-popover>
</template>
<script setup lang="ts">
  import { SearchOutlined } from '@ant-design/icons-vue'
  import SelectOptions from './components/SelectOptions.vue'
  const props = defineProps({
    value: {
      type: [String, Number, Array],
    },
    options: {
      type: Array<any>,
      default: () => [],
    },

    mode: {
      type: String,
    },
    fieldNames: {
      type: Object,
      default: () => ({
        label: 'label',
        value: 'value',
        options: 'children',
      }),
    },
  })
  const emit = defineEmits(['change', 'update:value'])

  const hasChild = computed(() => props.options.some((option) => option[props.fieldNames.options]))

  // 关键词搜索
  const keyword = ref()
  const filterOptions = (options: any = []) => {
    return options.filter((i: any) =>
      i[props.fieldNames.label].toLocaleLowerCase().includes(keyword.value.toLocaleLowerCase()),
    )
  }
  const localOptions = computed(() => {
    if (keyword.value) {
      if (hasChild.value) {
        return props.options.reduce((acc, cur) => {
          const children = filterOptions(cur[props.fieldNames.options])
          acc.push({ ...cur, [props.fieldNames.options]: children })
          return acc
        }, [])
      } else {
        return filterOptions(props.options)
      }
    } else {
      return props.options
    }
  })

  // 初始化值
  const visible = ref(false)
  watch(
    () => visible.value,
    () => setTimeout(() => (keyword.value = ''), 200),
  )

  const handleCheckChange = (value, checked) => {
    let tempValue = [...localValue.value]
    if (checked) {
      if (props.mode) {
        tempValue.push(value)
      } else {
        tempValue = [value]
      }
    } else {
      const valueIndex = tempValue.indexOf(value)
      tempValue.splice(valueIndex, 1)
    }
    localValue.value = tempValue
  }

  const localValue = computed({
    get() {
      if (props.mode) {
        return Array.isArray(props.value) ? [...props.value] : []
      } else {
        return props.value ? [props.value] : []
      }
    },
    set(newValue: any) {
      let value
      if (props.mode) {
        value = newValue
      } else {
        value = newValue[0]
        visible.value = false
      }
      emit('change', value)
      emit('update:value', value)
    },
  })
</script>

<style lang="less" scoped>
  ::v-deep {
    .ant-tabs-tab {
      margin-top: 4px !important;
      padding: 6px 18px !important;
    }
    .ant-tabs-tab-active {
      background: #e6f7ff;
    }
    .ant-tabs-nav {
      max-height: 650px;
      overflow-y: auto;
    }
  }
</style>
